import { render, staticRenderFns } from "./AbaDadosIniciais.vue?vue&type=template&id=62b54128"
import script from "./AbaDadosIniciais.vue?vue&type=script&lang=ts"
export * from "./AbaDadosIniciais.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports